// Written by scripts/build-cloud-imagery.mjs: a hash of the cloud tiles' content,
// for the Cache Storage name (src/data/cloudImagerySource.js). Do not edit.
export const CLOUD_IMAGERY_BUILD = '29c81c50300e';
